export const GenericConstants = () => ({
    GENERIC_TEXT: {
        HEADER_TEXT: "eK Link",
    },
    LOGIN_TEXT: {
        HEADER: "Welcome to eK Link",
        SUB_HEADER: "Login to access your dashboard"
    },
    SIGNUP_TEXT: {
        HEADER: "Create your account",
        SUB_HEADER: "Join our digital agriculture ecosystem"
    }
});